import { CurrencyCode, Flag } from '@treasuryspring/spring-ui';
import classNames from 'classnames';

interface CurrencyLabelProps {
  currency?: string;
  className?: string;
  disabled?: boolean;
}

export default function CurrencyLabel({
  currency,
  className,
  disabled,
}: CurrencyLabelProps) {
  if (!currency) {
    return (
      <div
        className={classNames(
          'gap-xs flex items-center justify-start',
          className,
          {
            'text-placeholder': disabled,
          }
        )}
      >
        ???
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'gap-xs flex items-center justify-start',
        className,
        {
          'text-placeholder': disabled,
        }
      )}
    >
      <Flag currency={currency as CurrencyCode} countryCode="" svg />
      {currency}
    </div>
  );
}
